import React from 'react';
import ImageUploader from './ImageUploader';
import { getImageUrl } from '../utils/helpers';

function AnswerOptions({ 
  step, 
  stepIndex, 
  planId, 
  onOptionImageUpload,
  onUpdateQuestionOption,
  onAddQuestionOption,
  onRemoveQuestionOption,
  onImageClick
}) {
  if (!step.question) return null;

  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <div>
      <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Answer Options</label>
      {step.question.options.map((option, optIndex) => (
        <div key={optIndex} style={{ 
          marginBottom: '1rem', 
          padding: '1rem', 
          border: `1px solid ${isDarkMode ? '#4b5563' : '#e2e8f0'}`, 
          borderRadius: '8px',
          backgroundColor: isDarkMode ? '#374151' : '#ffffff'
        }}>
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <input
              type="text"
              className="form-control"
              value={option}
              onChange={(e) => onUpdateQuestionOption(stepIndex, optIndex, e.target.value)}
              placeholder={`Option ${optIndex + 1}`}
            />
            {option.trim() && (
              <ImageUploader
                compact={true}
                planId={planId}
                onImageUpload={(files) => onOptionImageUpload(stepIndex, option, files)}
                images={step.question.option_images?.[option] || []}
                onImageClick={onImageClick}
                showPreview={true}
              />
            )}
            {step.question.options.length > 2 && (
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => onRemoveQuestionOption(stepIndex, optIndex)}
                style={{ padding: '0.5rem' }}
              >
                🗑️
              </button>
            )}
          </div>
          {option.trim() && step.question.option_images?.[option] && step.question.option_images[option].length > 0 && (
            <div className="image-preview" style={{ marginTop: '0.5rem' }}>
              {step.question.option_images[option].map((image, imgIndex) => (
                <img 
                  key={imgIndex} 
                  src={getImageUrl(image, planId)} 
                  alt={`${option} ${imgIndex + 1}`}
                  style={{ cursor: 'pointer', maxHeight: '100px' }}
                  onClick={() => onImageClick(image)}
                />
              ))}
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => onAddQuestionOption(stepIndex)}
        style={{ marginTop: '0.5rem' }}
      >
        ➕ Add Option
      </button>
    </div>
  );
}

export default AnswerOptions; 